/**
 * Created by Daniela on 23/01/2017.
 */
export class TipoAjuste {
    dataCriacao: string;
    dataUltimaAlteracao: string;
    ativo: boolean;
    tipo: string;
    id: number;
    usuarioCriacaoId: number;
    usuarioUltimaAlteracaoId: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tipo-ajustes/shared/tipo-ajuste.model.ts
 **/